/** @typedef {import('@/types/cms').GeoOblast} GeoOblast */

export const REGION_SERVICE_LABELS = {
  construction: 'будівництво',
  facade: 'фасад',
  repair: 'ремонт',
};

export const REGION_SERVICE_COLORS = {
  будівництво: 'bg-blue-500/10 text-blue-400 border-blue-500/20',
  фасад: 'bg-gold/10 text-gold border-gold/20',
  ремонт: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
};

/**
 * @param {GeoOblast[]} geoArea
 */
export function mapGeoAreaToRegions(geoArea = []) {
  return geoArea.map((oblast) => ({
    name: oblast.oblast,
    short: oblast.short,
    color: oblast.color,
    desc: oblast.description || '',
    districts: (oblast.cities || []).map((city) => ({
      name: city.display_name || city.name,
      slug: city.slug,
      href: city.href || '',
      desc: city.description || '',
      services: (city.services || []).map((service) => REGION_SERVICE_LABELS[service] || service),
    })),
  }));
}

/**
 * @param {import('@/types/cms').RegionsSectionRegion[]} regions
 */
export function normalizeBlockRegions(regions = []) {
  return regions
    .filter((region) => region?.name)
    .map((region) => ({
      name: region.name,
      short: region.short || '',
      color: region.color || '#c9a227',
      desc: region.desc || region.description || '',
      districts: (region.districts || [])
        .filter((district) => district?.name && district?.slug)
        .map((district) => ({
          name: district.name,
          slug: district.slug,
          href: district.href || '',
          desc: district.desc || district.description || '',
          services: (district.services || []).map((service) => REGION_SERVICE_LABELS[service] || service),
        })),
    }));
}
